<template>
    <div class="main main-padding">
        <!-- 备课助手总用户数、 备课助手使用次数Top5用户、备课助手每周使用人数 -->
        <Row :gutter="10" style="margin-top: 20px;">
            <Col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                <Card style="height:413px;">
                    <div style="text-align:center; font-weight: bold;">
                        <img src="../../../assets/images/assistant.png" style="margin-top: 14%;">
                        <div style="margin-top: -2%;font-size:37px">备课助手总用户数:{{baseData.preAssUser}}</div>
                    </div>
                </card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                <histogram-charts
                    :chartsTitle="'备课助手使用次数Top5用户'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pre_user_top'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="preUserTop"
                ></histogram-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                <line-charts
                    :chartsTitle="'备课助手每周使用人数'"
                    :chartsId="'pre_week_user'"
                    :lineCompany="'人'"
                    ref="preWeekUser"
                ></line-charts>
            </Col>
        </Row>
        <!--  课堂活动、备课助手最近30天日活数、备课助手各版本用户分布 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'课堂活动'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pre_class_action'"
                    :pieChartsName="'课堂活动'"
                    ref="preClassAction"
                ></pie-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <line-charts
                    :chartsTitle="'备课助手最近30天日活数'"
                    :chartsId="'pre_nearly_month_user'"
                    :lineCompany="'人'"
                    ref="preNearlyMonthUser"
                ></line-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'备课助手各版本用户分布'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pre_version_distri'"
                    :pieChartsName="'版本分布'"
                    ref="preVersionDistri"
                ></pie-charts>
            </Col>
        </Row>
        <!--  各校备课助手用户数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'各校备课助手用户数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'pre_school_user'"
                    :height="'360px'"
                    :histogramTooltip="'people'"
                    ref="preSchoolUser"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  备课助手使用用户学科分布 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'备课助手使用用户学科分布'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'pre_sub_distri'"
                    :height="'360px'"
                    :histogramTooltip="'people'"
                    ref="preSubDistri"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  备课助手月活用户数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <line-charts
                    :chartsTitle="'备课助手月活用户数'"
                    :chartsId="'pre_month_user'"
                    :lineCompany="'人'"
                    ref="preMonthUser"
                ></line-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {
        findLessonPreparationUseNum,
        findLesPreUseWeekly,
        findZnbkActivity,
        findLesPreDayNum,
        findLessPreVersionNum,
        findLesPreMonthUseNum,
        findLesPreUseRanking,
        findLesPreSchoolUseNum,
        findLesPreSubjectUseNum
    } from "../../../service/api.js";

    export default {
        name: "prepare-main",
        data () {
            return {
                baseData: {
                    preAssUser: 0  //备课助手总用户数
                }
            };
        },
        components: {
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 获取学校使用数量
             */
            async getLessonPreparationUseNum () {
                let _this = this;
                await findLessonPreparationUseNum()
                    .then(function (data) {
                        _this.baseData.preAssUser = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课使用排行Top
             */
            async getLesPreUseRanking () {
                let _this = this;
                await findLesPreUseRanking()
                    .then(function (data) {
                        let rankList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < rankList.length; i++) {
                            xDataArr.push(rankList[i].fullName);
                            seriesDataArr.push(rankList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preUserTop.initDataSource(rankList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手学校用户总数
             */
            async getLesPreSchoolUseNum () {
                let _this = this;
                await findLesPreSchoolUseNum()
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].schoolName);
                            seriesDataArr.push(schoolList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preSchoolUser.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手每周使用人次
             */
            async getLesPreUseWeekly () {
                let _this = this;
                await findLesPreUseWeekly()
                    .then(function (data) {
                        let numList = data;
                        let weekArr = [];
                        let countArr = [];
                        for (let i = 0; i < numList.length; i++) {
                            let strWeekStr = numList[i].dates.substring(5, 11);
                            let endWeekStr = numList[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            weekArr.push(weekStr);
                            countArr.push(numList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preWeekUser.initDataSource(numList, weekArr, countArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取课堂活动
             */
            async getZnbkActivity () {
                let _this = this;
                await findZnbkActivity()
                    .then(function (data) {
                        let actionList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < actionList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = actionList[i].count;
                            obj.name = actionList[i].resTypeName;
                            dataArr.push(obj);
                            nameArr.push(actionList[i].resTypeName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preClassAction.initDataSource(actionList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手最近30天日活数
             */
            async getLesPreDayNum () {
                let _this = this;
                await findLesPreDayNum()
                    .then(function (data) {
                        let activeList = data;
                        let monthArr = [];
                        let countArr = [];
                        for (let i = 0; i < activeList.length; i++) {
                            monthArr.push(activeList[i].day);
                            countArr.push(activeList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preNearlyMonthUser.initDataSource(activeList, monthArr, countArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手各版本用户分布
             */
            async getLessPreVersionNum () {
                let _this = this;
                await findLessPreVersionNum()
                    .then(function (data) {
                        let versionList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < versionList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = versionList[i].count;
                            obj.name = versionList[i].productVersion;
                            dataArr.push(obj);
                            nameArr.push(versionList[i].productVersion);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preVersionDistri.initDataSource(versionList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手用户学科分布top10
             */
            async getLesPreSubjectUseNum () {
                let _this = this;
                await findLesPreSubjectUseNum()
                    .then(function (data) {
                        let subList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < subList.length; i++) {
                            xDataArr.push(subList[i].subName);
                            seriesDataArr.push(subList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preSubDistri.initDataSource(subList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取备课助手月活用户
             */
            async getLesPreMonthUseNum () {
                let _this = this;
                await findLesPreMonthUseNum()
                    .then(function (data) {
                        let userList = data;
                        let monthArr = [];
                        let countArr = [];
                        for (let i = 0; i < userList.length; i++) {
                            monthArr.push(userList[i].month);
                            countArr.push(userList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.preMonthUser.initDataSource(userList, monthArr, countArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "备课助手产品使用统计");
            //获取学校使用数量
            this.getLessonPreparationUseNum();
            //获取备课使用排行Top
            this.getLesPreUseRanking();
            //获取备课助手每周使用人数
            this.getLesPreUseWeekly();
            //获取课堂活动
            this.getZnbkActivity();
            //获取 备课助手最近30天日活数
            this.getLesPreDayNum();
            //获取备课助手各版本用户分布
            this.getLessPreVersionNum();
            //获取备课助手学校用户总数
            this.getLesPreSchoolUseNum();
            //获取备课助手用户学科分布top10
            this.getLesPreSubjectUseNum();
            //获取备课助手月活用户
            this.getLesPreMonthUseNum();

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    /*.mian {*/
    /*margin: 0.5%;*/
    /*}*/
</style>
